import { Spin } from "antd";
import { MonthlyEarningIcon } from "../../icons";
import totalEarningChartImage from "icons/totalEarningCardBackground.png";
import styles from "./styles.module.scss";

export const MonthlyEarning = ({ height, totalEarned = 0, loading }) => {
  return (
    <Spin spinning={loading}>
      <div className={styles.monthlyEarningContainer}>
        <div className={styles.header}>
          <div className={styles.circleWithIcon}>
            <MonthlyEarningIcon />
          </div>
          <div className={styles.title}>Monthly Earning</div>
        </div>
        <div className={styles.content} style={{ height: height - 75 + "px" }}>
          <div className={styles.totalEarned}>
            <div className={styles.label}>Total Earned</div>
            <div className={styles.value}>€{totalEarned}</div>
          </div>
          <div className={styles.totalSpend}>
            <div className={styles.label}>Total Spent</div>
            <div className={styles.value}>€480,545</div>
          </div>

          <img
            src={totalEarningChartImage}
            alt="totalEarningChartImage"
            className={styles.chartOnBackground}
          />
        </div>
      </div>
    </Spin>
  );
};
